function initScrollEffects(){
    // init sticky containers
    /*var $stickyParents = $('.frame-container-type-container-sticky');

    if ($stickyParents) {
        var controller = new ScrollMagic.Controller({
            globalSceneOptions: {
                triggerHook: 'onLeave',
            }
        });

        var scenes = [];
        $stickyParents.each(function (idx) {
            var stickyContainer = $(this).find('.frame-type-container-sticky').get(0);
            // add 1 to duration to prevent bug when sticky element has same height as parent
            scenes[idx] = new ScrollMagic.Scene({
                triggerElement: this,
                duration: this.offsetHeight - stickyContainer.offsetHeight + 1
            })
                .setPin(stickyContainer, {pushFollowers: false})
                .addTo(controller);
        });

        $(window).resize(function() {
            $stickyParents.each(function (idx) {
                var stickyContainer = $(this).find('.frame-type-container-sticky').get(0);
                scenes[idx].duration(this.offsetHeight - stickyContainer.offsetHeight + 1);
            });
        });
    }*/

    var $stickyParents = $('.sticky-column');

    if ($stickyParents) {
        var controller = new ScrollMagic.Controller({
            globalSceneOptions: {
                triggerHook: 'onLeave',
            }
        });

        var scenes = [];
        $stickyParents.each(function (idx) {
            var stickyContainer = $(this).find('.sticky-column-wrap').get(0);
            // add 1 to duration to prevent bug when sticky element has same height as parent
            scenes[idx] = new ScrollMagic.Scene({
                triggerElement: this,
                duration: this.offsetHeight - stickyContainer.offsetHeight + 1
            })
                .setPin(stickyContainer, {pushFollowers: false})
                .addTo(controller);
        });

        $(window).resize(function() {
            $stickyParents.each(function (idx) {
                var stickyContainer = $(this).find('.sticky-column-wrap').get(0);
                scenes[idx].duration(this.offsetHeight - stickyContainer.offsetHeight + 1);
            });
        });
    }
}